export default [
     {
          path: '/project-details/:id',
          name: 'ProjectDetails',
          component: () => import("@/views/Page/StrategicPlan/Project/ProjectDetails.vue"),
           meta: {
               title: 'ProjectDetails',
               permission: 'Project.show',
          },
     }
];